// extracted by mini-css-extract-plugin
var _1 = "RequestProfileWidgetSideWorkers-modulecontent__VVcwP WidgetContentContainer-moduleWidgetContentContainer__HxIkI";
export { _1 as "content" }
